import { Component, Input, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { Offer, getPrice } from '../_models/offer';
import { User } from '../_models/user';
import { CartService } from '../_services/cart.service';
import { WishlistService } from '../_services/wishlist.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AppConstants } from '../_constants/constants';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-related-products',
    templateUrl: './related-products.component.html',
    styleUrls: ['./related-products.component.css'],
    standalone: false
})
export class RelatedProductsComponent implements OnInit {
    @Input() relatedProducts: any[];
    @Input() loadingState: boolean;

    defaultImage = '/assets/images/default.jpg';
    currentLanguage: string | null = null;
    user: User = null;

    slideConfig = {
        autoplay: false,
        dots: false,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 2,
        centerMode: false,
        nextArrow: '<button class="btn nextBtn"><i class="fa fa-lg fa-angle-right"></i></button>',
        prevArrow: '<button class="btn prevBtn"><i class="fa fa-lg fa-angle-left"></i></button>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    constructor(
        private cartService: CartService,
        private toastService: ToastrService,
        private translateService: TranslateService,
        private wishlistService: WishlistService,
        private router: Router,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        if (isPlatformBrowser(this.platformId)) {
            this.user = JSON.parse(localStorage.getItem('currentUser') ?? '{}');
        }
    }

    addProductToCart(offer: any) {
        this.cartService.addToLocalCart(offer).subscribe(
            () => {
                const addCartMessage = this.translateService.get('common.message_for_added_to_cart')
                    .subscribe(message => {
                        this.toastService.success(message);
                    });
            }
        );
    }

    addToWishlist(offer: any, event: Event): void {
        event.stopPropagation();
        event.preventDefault();

        if (!this.user || !this.user.id) {
            localStorage.setItem('pendingWishlistOfferId', offer.id.toString());
            this.router.navigate(['/signin'], {
                queryParams: { returnUrl: this.router.url }
            });
            return;
        }

        this.wishlistService.addToWishList(this.user.id, offer.id)
            .subscribe({
                next: () => {
                    this.translateService.get('common.message_for_added_to_wishlist')
                        .subscribe(message => {
                            this.toastService.success(message);
                        });
                },
                error: (error) => {
                    if (error.status === 409 || error.error?.message?.includes('already')) {
                        this.toastService.info('This item is already in your wishlist');
                    } else {
                        this.toastService.error('Failed to add to wishlist');
                    }
                }
            });
    }

    getOfferPrice(offer: Offer): number {
        return getPrice(offer);
    }

    getImageSrc(offer: Offer) {
        return environment.image_cdn_url + '/' +
            (offer.defaultPicture.length > 0 ? offer.defaultPicture + '?func=crop&width=280&height=280' : offer.product.picture);
    }

    slickInit() {}
    breakpoint() {}
    afterChange() {}
    beforeChange() {}

    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.currentLanguage = localStorage.getItem(AppConstants.CURRENT_LANG_STORE_KEY);
        }
    }
}
